const ITEMS = [
  "DA vs CDC Guidance",
  "128 NSW Councils",
  "Bushfire & Flood Due Diligence",
  "LEP & DCP Translation",
  "Exempt Development Checklists",
  "Section 10.7 Certificates",
  "Expert Advisory",
  "Instant PDF Toolkits",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-8 text-sm font-mono uppercase tracking-[0.22em] text-teal/70">
          {item}
        </span>
        <span className="w-1.5 h-1.5 rotate-45 bg-sand" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    className="border-y border-cloud bg-ivory py-4 overflow-hidden marquee-mask"
    data-testid="editorial-marquee"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
